import React from 'react';
import classnames from 'classnames';

import './index.css';

const Section = ({className, ...rest}) => <div {...rest} className={classnames('section', className)} />

export const Section1 = (props) => <Section {...props} className="section_1" />
